export default "__VITE_ASSET__B6G0TYW1__"